<template>
  <div class="process-container">
    <span class="process-bar">
      <span class="process-ball"></span>
    </span>
    <span class="process-text">{{text}}</span>
  </div>
</template>
<script>
export default {
  props:{
    text:{
      type: String,
      default: "上传中，请稍等..."
    }
  }
}
</script>
<style lang="less">
@keyframes process {
  from {margin-left: -50px;}
  to {margin-left: 268px;}
}
  .process-container{
    width:100%;
    .process-bar{
      width: 268px;
      height:16px;
      border-radius: 8px;
      background-color: #eefcf9;
      display: inline-block;
      text-align: left;
      overflow: hidden;
      .process-ball{
        display: inline-block;
        width: 50px;
        height: 16px;
        border-radius: 8px;
        background-color: #57dec1;
        margin-left: 0px;
        animation: process 2.5s infinite;
      }
    }
    .process-text{
      color: #333333;
      font-size: 16px;
      display: block
    }
  }
</style>